// Components
import Image from "next/image";

const MockupItem = ({item: {img, id}}) => {
    return (
        <div className="mockup">
        <Image
            key={id}
            src={img}
            width={250}
            height={491}
            alt="vclinic-mobile-app-screen-shots"
            className='mockup'
            priority={true}
        />
        </div>
    )
}

export default MockupItem;